import { useEffect, useState } from "react";
import { getUserPoints, UserPointData } from "api/points";
import LeftPointCard from "./LeftPointCard";
import RightRankingCard from "./RightRankingCard";

export default function LoyaltyPointSection() {
    const [pointData, setPointData] = useState<UserPointData | null>(null);

    useEffect(() => {
        const loadPoints = async () => {
            const response = await getUserPoints();
            if (response?.status && response.data) {
                setPointData(response.data);
            }
        };

        loadPoints();
    }, []);

    return (
        <div
            className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-item"
            style={{ marginBottom: "1px" }}
        >
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-5">
                <LeftPointCard pointBalance={pointData?.point_balance || 0} />
            </div>

            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-7">
                <RightRankingCard
                    pointData={pointData || undefined}
                    pointTotal={pointData?.point_total || 0}
                    currentLevel={pointData?.level || ""}
                    nextLevel={pointData?.next_level || ""}
                    percent={pointData?.percent || 0}
                    levelImage={pointData?.level_avatar}
                    nextLevelImage={pointData?.next_level_avatar}
                />
            </div>
        </div>
    );
}